import Icon from 'components/icon';
import styles from './styles.module.scss';

type Empty = {
  iconName: string,
  title: string,
  message: string
}

function Empty(props : Empty) : JSX.Element {
  return (
    <div className={styles['biobar-notifications-empty']}>
      <div className={styles.icon}>
        <Icon iconName={props.iconName} useOutlined={true}/>
      </div>

      <p>{props.title}</p>
      <p>{props.message}</p>
    </div>
  );
}

export default Empty;